import React from "react";
import LazyImage from "ComponentsUI/Image";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "100%",
		padding: "0 35px",
		display: "flex",
		justifyContent: "center",
		flexWrap: "wrap",
	},
	img: {
		margin: "0 8px 10px 0",
		objectFit: "scale-down",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		img: {
			width: "100px",
			height: "100px",
		},
	},
	[`@media (max-width: ${theme.media.md})`]: {
		root: {
			padding: 0,
		},
		img: {
			width: "72px",
			height: "72px",
		},
	},
}));

const ProvidersLogoBlock = ({ providers, ...props }) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			{providers.map(({ logo, name }, index) => {
				return (
					<LazyImage
						width={130}
						height={130}
						src={logo}
						className={classes.img}
						alt={`Логотип ${name}`}
						key={index}
					/>
				);
			})}
		</div>
	);
};

export default ProvidersLogoBlock;
